export const useSegmentStore = defineStore('segmentStore', () => {
	// State
	const eventQueue = ref([] as { event: string, eventParams?: object }[])
	const isSegmentLoaded = ref(false)

	// Actions
	const addToQueue = (event: string, eventParams?: object) => {
		if (eventQueue.value.length >= 10) {
			eventQueue.value.shift() // Remove the oldest event to maintain the limit
		}
		eventQueue.value.push({ event, eventParams })
	}

	const processQueue = (callback: (event: string, eventParams?: object)=> void) => {
		const initialLength = eventQueue.value.length // Safeguard: Store initial length
		let iterations = 0

		while (eventQueue.value.length > 0) {
			if (iterations >= initialLength) {
				console.warn('processQueue: Exceeded initial queue length. Exiting to prevent infinite loop.')
				break
			}
			const { event, eventParams } = eventQueue.value.shift()!
			callback(event, eventParams)
			iterations++
		}
	}

	const setSegmentLoaded = () => {
		isSegmentLoaded.value = true
	}

	return {
		eventQueue,
		isSegmentLoaded,
		addToQueue,
		processQueue,
		setSegmentLoaded
	}
})
